var app = angular.module('leonardo');

var ReportsMimoListFilters = function (
  $scope,
  $controller,
  $timeout,
  $rootScope,
  ReportService,
  UnitService,
  UnitTypeService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersMimo;

  $scope.filters_options = [];

  $scope.initOptions = function () {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'building',
        name: 'Building Number',
        label: 'Building Number',
        inline: false,
        type: 'text',
        placeholder: 'Building Number',
        condition: true,
        conflicts: ['property_reports'],
        onSubmit: $scope.display
      },
      {
        id: 'unit_number',
        name: 'Unit Number',
        label: 'Unit Number',
        inline: false,
        type: 'text',
        placeholder: 'Unit Number',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'unit',
        name: 'Unit',
        label: 'Unit',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Unit',
        condition: true,
        service: UnitService,
        conflicts: ['unit_type']
      },
      {
        id: 'unit_type',
        name: 'Unit Type',
        label: 'Unit Type',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'Select Unit Type',
        condition: true,
        service: UnitTypeService,
        conflicts: ['unit']
      },
    ]);
  };

  $scope.initOptions();

  $rootScope.$broadcast('filters-report:initialized');

  $timeout(function () {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_MIMO);
  }, 100);
};

app.controller('ReportsMimoListFilters', [
  '$scope',
  '$controller',
  '$timeout',
  '$rootScope',
  'ReportService',
  'UnitService',
  'UnitTypeService',
  ReportsMimoListFilters
]);
